import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import {
  TranslateModule,
  TranslatePipe,
  TranslateService,
} from '@ngx-translate/core';
import { UserService } from '../../service/user.service';
import { LanguageSettingComponent } from './language-setting/language-setting.component';
import { EmailNotificationsSettingComponent } from './email-notifications-setting/email-notifications-setting.component';
import { ParentButtonComponent } from '../../../../shared/components/ui/parent-button/parent-button.component';

@Component({
  selector: 'app-settings',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    TranslatePipe,
    LanguageSettingComponent,
    EmailNotificationsSettingComponent,
    ParentButtonComponent,
  ],
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.scss',
})
export class SettingsComponent {
  #userService = inject(UserService);
  #translate = inject(TranslateService);

  form = new FormGroup({
    language: new FormControl<string>('en', { nonNullable: true }),
    notificationsEmail: new FormControl<boolean>(true, { nonNullable: true }),
  });

  isSaving = signal(false);

  async save(): Promise<void> {
    const { language, notificationsEmail } = this.form.getRawValue();
    if (!language) return;

    try {
      this.isSaving.set(true);
      await this.#userService.updateSettings.mutateAsync({
        language,
        notificationsEmail,
      });
      this.#translate.use(language);
    } finally {
      this.isSaving.set(false);
    }
  }
}
